import React, { Component } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { utcToLocal, utcToDate } from "../../utils/dateConvert";
import TimeAgo from "timeago-react";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import AlertEventIcon from "../common/alertEventIcon";

class AlertTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
      //states for modal
      modalId: "",
      modalEvent: "",
      modalAsset: "",
      modalCreated: "",
      modalDifference: "",
      modalAddress: "",
      modalCutomerName: "",
      acknowledgementDescription: "",
      modalUserId: "",
      ackDesc: "",
      modalAcknowledgeTime: "",
      modalUserName: "",
      searchTerm: "",
      // rowColor: false,
    };
  }
  componentDidMount() {
    setTimeout(() => {
      console.log("this.props", this.props.data);
    }, 2000);
  }
  handleClose = () => {
    this.setState({
      modalShow: false,
    });
  };
  acknowledgeClick = (id, description) => {
    this.props.handleAcknowledege(id, description);
    // this.props.setLoadingPageAction(true);
    this.setState({
      modalShow: false,
      rowColor: false,
      acknowledgementDescription:''
    });
    // this.props.rowColor(false)
  };

  handleAcknowledegmentDescription = (e) => {
    console.log("etarget", e.target.value);
    this.setState({
      acknowledgementDescription: e.target.value,
    });
  };
  handleAcknowledged = (
    event,
    asset,
    created,
    difference,
    address,
    customer,
    id,
    userId,
    ackMsg,
    usrname,
    ackTime
  ) => {
    this.setState({
      modalShow: true,
      modalId: id,
      modalEvent: event,
      modalAsset: asset,
      modalCutomerName: customer,
      modalAddress: address,
      modalCreated: created,
      modalDifference: difference,
      modalUserId: userId,
      ackDesc: ackMsg,
      modalUserName: usrname,
      modalAcknowledgeTime: ackTime,
    });
  };
  handleShow = (event, asset, created, difference, address, customer, id) => {
    this.setState({
      modalUserId: "",
      ackDesc: "",
      modalShow: true,
      modalId: id,
      modalEvent: event,
      modalAsset: asset,
      modalCutomerName: customer,
      modalAddress: address,
      modalCreated: created,
      modalDifference: difference,
    });
  };

  renderEvents = (event, index) => {
      if (this.props.isTemperature) {
          return this.renderTemperatureEvent(event, index);
      } else {
          // Existing event rendering logic
          return (
              <tr
                  key={index}
                  style={
                      event.userId
                          ? { background: "#DFF0D9" }
                          : { position: "relative" }
                  }
                  className={`${event.rowColor ? "tableRowFlicker" : ""} `}
              >
                  <td>
                      <AlertEventIcon event={event} />

                      &nbsp;
                      {event.uniqueId !== null && event.uniqueId !== 0 ? event.eventName + " - [" + event.uniqueId + "]" : event.eventName}
                      </td>
                  <td>
                      {" "}
                      {
                          <TimeAgo
                              datetime={utcToLocal(event.gPRMC.created)}
                          // locale='zh_CN'
                          />
                      }{" "}
                      - {utcToDate(event.gPRMC.created)}
                  </td>

                  <td>{event.assetName}</td>
                  <td>{event.customerName}</td>
                  <td>{event.location}</td>
                  <td>
                      <center>
                          {event.userId ? (
                              <div>
                                  {utcToLocal(event.acknowledgeTime)}
                                  <br />
                                  <button
                                      className="info"
                                      onClick={() =>
                                          this.handleAcknowledged(
                                              event.eventName,
                                              event.assetName,
                                              event.created,
                                              event.difference,
                                              event.location,
                                              event.customerName,
                                              event.id,
                                              event.userId,
                                              event.acknowledgedDescription,
                                              event.userName,
                                              event.acknowledgeTime
                                          )
                                      }
                                  >
                                      <i className="fa fa-info" />
                                  </button>
                              </div>
                          ) : (
                              <Button
                                  variant="danger"
                                  onClick={() => {

                                      this.handleShow(
                                          event.eventName,
                                          event.assetName,
                                          event.created,
                                          event.difference,
                                          event.location,
                                          event.customerName,
                                          event.id
                                      )
                                  }}
                                  size="sm"
                              >
                                  <i className="fa fa-check" />
                              </Button>
                          )}
                      </center>
                  </td>
              </tr>
          );
      }
  };

  renderTemperatureEvent = (event, index) => {
      return (
          <tr key={index} className={event.rowColor ? "highlight-row" : ""}>
              <td>Out of Threshold</td>
              <td>{event.tempAlertSensor}</td>
              <td>{`${event.tempAlertRuleType} ${event.tempAlertThreshold}°C`}</td>
              <td>{event.sensorAValue || event.sensorBValue}</td>
              <td>{this.formatDateTime(event.tempAlertStartTime || event.created)}</td>
              <td>{this.formatDateTime(event.tempAlertEndTime)}</td>
              <td>{event.tempAlertDuration} mins</td>
              <td>{event.friendlyName || event.assetName}</td>
              <td>{event.customerName}</td>
              <td>{event.tempAlertStartAddress || event.location}</td>
              <td>{event.tempAlertEndAddress || event.location}</td>
              <td>{event.tempAlertEmailSent}</td>
              <td>
                  {event.userId === null ? (
                      <button
                          className="btn btn-primary acknow-btn"
                          onClick={() => this.handleAcknowledgeButton(event)}
                      >
                          Acknowledge
                      </button>
                  ) : (
                      <>
                          <p className="alert-user">
                              {event.userName}
                          </p>
                          <p className="alert-description">
                              {event.acknowledgedDescription}
                          </p>
                          <p className="alert-time">
                              {this.formatDateTime(event.acknowledgeTime)}
                          </p>
                      </>
                  )}
              </td>
          </tr>
      );
  };

  renderTableHeader = () => {
      if (this.props.isTemperature) {
          return (
              <tr>
                  <th>Event</th>
                  <th>Sensor</th>
                  <th>Threshold</th>
                  <th>Recorded Temperature</th>
                  <th>Start</th>
                  <th>End</th>
                  <th>Duration</th>
                  <th>Asset</th>
                  <th>Customer</th>
                  <th>Start Address</th>
                  <th>End Address</th>
                  <th>Emailed</th>
                  <th>Acknowledge</th>
              </tr>
          );
      } else {
          return (
              <tr>
                  <th>Status</th>
                  <th>Event</th>
                  <th>Asset Name</th>
                  <th>Friendly Name</th>
                  <th>Customer</th>
                  <th>Location</th>
                  <th>Acknowledge</th>
              </tr>
          );
      }
  };

  formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    const date = new Date(dateTimeStr);
    return date.toLocaleString();
  };

  getRows = () => {
    return Array.isArray(this.props.data) ? this.props.data : [];
  };

  handleSearchChange = (event) => {
    this.setState({ searchTerm: event.target.value });
  };

  clearSearch = () => {
    this.setState({ searchTerm: "" });
  };

  getSearchableText = (event) => {
    const timestamp = this.getEventTimestamp(event);
    const values = [
      this.getEventLabel(event),
      event.assetName,
      event.friendlyName,
      event.customerName,
      event.location,
      event.tempAlertStartAddress,
      event.tempAlertEndAddress,
      event.tempAlertSensor,
      event.tempAlertLowTemp,
      event.tempAlertHighTemp,
      event.tempAlertActualTemp,
      event.tempAlertDuration,
      event.userName,
      event.acknowledgedDescription,
      event.userId ? "acknowledged resolved" : "pending review",
      timestamp,
      timestamp ? utcToDate(timestamp) : "",
    ];

    return values
      .filter((value) => value !== null && value !== undefined)
      .join(" ")
      .toLowerCase();
  };

  getFilteredRows = () => {
    const rows = this.getRows();
    const query = this.state.searchTerm.trim().toLowerCase();

    if (!query) {
      return rows;
    }

    return rows.filter((event) => this.getSearchableText(event).includes(query));
  };

  getEventTimestamp = (event) => {
    if (!event) {
      return null;
    }

    return event.tempAlertStartTime || event.gPRMC?.created || event.created || event.received;
  };

  getEventLabel = (event) => {
    if (this.props.isTemperature) {
      return event.tempAlertRuleType
        ? `Temperature ${event.tempAlertRuleType}`
        : event.eventName || "Temperature Alert";
    }

    return event.uniqueId !== null && event.uniqueId !== 0
      ? `${event.eventName} - [${event.uniqueId}]`
      : event.eventName;
  };

  renderOccurred = (event) => {
    const timestamp = this.getEventTimestamp(event);

    if (!timestamp) {
      return <span className="alertMutedText">Not available</span>;
    }

    return (
      <div className="alertOccurred">
        <strong>
          <TimeAgo datetime={utcToLocal(timestamp) || timestamp} />
        </strong>
        <span>{utcToDate(timestamp) || this.formatDateTime(timestamp)}</span>
      </div>
    );
  };

  openAcknowledgeModal = (event) => {
    const timestamp = this.getEventTimestamp(event);

    this.handleShow(
      this.getEventLabel(event),
      event.friendlyName || event.assetName,
      timestamp,
      timestamp,
      event.tempAlertStartAddress || event.location,
      event.customerName,
      event.id
    );
  };

  openAcknowledgedModal = (event) => {
    const timestamp = this.getEventTimestamp(event);

    this.handleAcknowledged(
      this.getEventLabel(event),
      event.friendlyName || event.assetName,
      timestamp,
      timestamp,
      event.tempAlertStartAddress || event.location,
      event.customerName,
      event.id,
      event.userId,
      event.acknowledgedDescription,
      event.userName,
      event.acknowledgeTime
    );
  };

  renderAcknowledgement = (event) => {
    if (event.userId) {
      return (
        <div className="alertAckState acknowledged">
          <span>
            <button type="button" className="alertInfoButton" onClick={() => this.openAcknowledgedModal(event)}>
              <i className="fa fa-info" />
            </button>
            Acknowledged
          </span>
          <small>{utcToLocal(event.acknowledgeTime)}</small>
        </div>
      );
    }

    return (
      <Button className="alertAckButton" variant="danger" onClick={() => this.openAcknowledgeModal(event)} size="sm">
        <i className="fa fa-check" />
        Acknowledge
      </Button>
    );
  };

  renderTableHeader = () => {
    if (this.props.isTemperature) {
      return (
        <tr>
          <th>Event</th>
          <th>Occurred</th>
          <th>Asset</th>
          <th>Sensor</th>
          <th>Allowed Range</th>
          <th>Actual Temp</th>
          <th>Duration</th>
          <th>Customer</th>
          <th>Address</th>
          <th className="alertAckHeader">Acknowledgement</th>
        </tr>
      );
    }

    return (
      <tr>
        <th>Event</th>
        <th>Occurred</th>
        <th>Asset</th>
        <th>Customer</th>
        <th>Address</th>
        <th className="alertAckHeader">Acknowledgement</th>
      </tr>
    );
  };

  renderStandardRow = (event, index) => {
    return (
      <tr key={event.id || index} className={`${event.rowColor ? "tableRowFlicker" : ""} ${event.userId ? "alertRowAcknowledged" : ""}`}>
        <td>
          <div className="alertEventCell">
            <AlertEventIcon event={event} className="alertEventIcon" />
            <div>
              <strong>{this.getEventLabel(event)}</strong>
              <small>{event.userId ? "Resolved" : "Pending review"}</small>
            </div>
          </div>
        </td>
        <td>{this.renderOccurred(event)}</td>
        <td className="alertAssetCell">{event.assetName || event.friendlyName || "-"}</td>
        <td>{event.customerName || "-"}</td>
        <td className="alertAddressCell">{event.location || "-"}</td>
        <td>{this.renderAcknowledgement(event)}</td>
      </tr>
    );
  };

  renderTemperatureRow = (event, index) => {
    const lowTemp = event.tempAlertLowTemp;
    const highTemp = event.tempAlertHighTemp;
    const thresholdRange =
      lowTemp !== null && lowTemp !== undefined && highTemp !== null && highTemp !== undefined
        ? `${lowTemp}°C to ${highTemp}°C`
        : "-";

    return (
      <tr key={event.id || index} className={`${event.rowColor ? "tableRowFlicker" : ""} ${event.userId ? "alertRowAcknowledged" : ""}`}>
        <td>
          <div className="alertEventCell">
            <AlertEventIcon event={event} isTemperature className="alertEventIcon" />
            <div>
              <strong>{this.getEventLabel(event)}</strong>
              <small>{event.userId ? "Resolved" : "Pending review"}</small>
            </div>
          </div>
        </td>
        <td>{this.renderOccurred(event)}</td>
        <td className="alertAssetCell">{event.friendlyName || event.assetName || "-"}</td>
        <td>{event.tempAlertSensor || "-"}</td>
        <td>{thresholdRange}</td>
        <td>{event.tempAlertActualTemp ? `${event.tempAlertActualTemp}°C` : "-"}</td>
        <td>{event.tempAlertDuration ? `${event.tempAlertDuration} mins` : "-"}</td>
        <td>{event.customerName || "-"}</td>
        <td className="alertAddressCell">{event.tempAlertStartAddress || event.location || "-"}</td>
        <td>{this.renderAcknowledgement(event)}</td>
      </tr>
    );
  };

  render() {
    const rows = this.getRows();
    const filteredRows = this.getFilteredRows();
    const hasSearch = this.state.searchTerm.trim() !== "";

    return (
      <div className="alertTableCard">
        <div className="alertTableHeading">
          <div>
            <h3>{this.props.alertMessage}</h3>
            <p>{hasSearch ? `${filteredRows.length} of ${rows.length} alert records shown` : `${rows.length} alert records loaded`}</p>
          </div>
          <div className="alertTableActions">
            <div className="alertSearchField">
              <i className="fa fa-search" />
              <input
                type="search"
                value={this.state.searchTerm}
                onChange={this.handleSearchChange}
                placeholder="Search alerts..."
                aria-label="Search alerts"
              />
              {hasSearch && (
                <button type="button" onClick={this.clearSearch} aria-label="Clear alert search">
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
            <button type="button" className="alertExportButton" onClick={() => this.props.downloadExcel()}>
              <i className="fa fa-file-excel-o" />
              Export
            </button>
          </div>
        </div>
        <div className="alertTableScroll">
          <Table className="alertTable">
            <thead>{this.renderTableHeader()}</thead>
            <tbody>
              {filteredRows.length > 0 ? (
                filteredRows.map((item, index) =>
                  this.props.isTemperature
                    ? this.renderTemperatureRow(item, index)
                    : this.renderStandardRow(item, index)
                )
              ) : (
                <tr>
                  <td colSpan={this.props.isTemperature ? 10 : 6}>
                    <div className="alertEmptyState">
                      <i className="fa fa-check-circle" />
                      <strong>{hasSearch ? "No matching alerts" : "No alerts to show"}</strong>
                      <span>{hasSearch ? "Try a different asset, customer, event, address or acknowledgement search." : "This tab has no alert records in the current alert window."}</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <Modal show={this.state.modalShow} size="lg" onHide={this.handleClose} className="alertCentreModal">
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.modalUserId == "" ? "Acknowledge alert" : <b>{this.state.modalEvent}</b>}{" "}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={this.state.modalUserId == "" ? "alertModalSummary pending" : "alertModalSummary acknowledged"}>
              <span className="alertModalIcon">
                <i className={`fa ${this.state.modalUserId == "" ? "fa-exclamation" : "fa-check"}`} />
              </span>
              <div>
                <strong>{this.state.modalEvent}</strong>
                <p>{this.state.modalAsset}</p>
              </div>
            </div>
            <div className="alertModalDetails">
              <div>
                <span>Occurred</span>
                <strong>
                  {utcToDate(this.state.modalCreated) || this.formatDateTime(this.state.modalCreated)}
                  {this.state.modalDifference ? (
                    <small>
                      <TimeAgo datetime={utcToLocal(this.state.modalDifference) || this.state.modalDifference} />
                    </small>
                  ) : ""}
                </strong>
              </div>
              <div>
                <span>Customer</span>
                <strong>{this.state.modalCutomerName || "-"}</strong>
              </div>
              <div className="alertModalAddress">
                <span>Address</span>
                <strong>{this.state.modalAddress || "-"}</strong>
              </div>
            </div>
            {this.state.modalUserId !== "" && (
              <div className="alertModalAcknowledged">
                <span>Acknowledgement</span>
                <strong>{this.state.ackDesc || "No remarks recorded"}</strong>
                <small>
                  Acknowledged by {this.state.modalUserName} on{" "}
                  {utcToDate(this.state.modalAcknowledgeTime) || this.formatDateTime(this.state.modalAcknowledgeTime)}
                </small>
              </div>
            )}
            {this.state.modalUserId == "" ? (
              <div className="alertModalRemarks">
                <label>Remarks</label>
                <Form>
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Control
                      as="textarea"
                      onChange={this.handleAcknowledegmentDescription}
                      placeholder="Optional remarks about your acknowledgement"
                      rows="3"
                    />
                  </Form.Group>
                </Form>
                <div className="modalGraph">
                  <i className="fa fa-info-circle" />
                  <span>
                    By acknowledging this alert you are confirming it has occurred and that it no longer needs to be included in the alert centre notification area. Alerts over 24 hours old are automatically removed.
                  </span>
                </div>
              </div>
            ) : ""}
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalUserId == "" ? (
              <div>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => {
                    this.acknowledgeClick(this.state.modalId, this.state.acknowledgementDescription);
                  }}
                >
                  Acknowledge
                </Button>
                &nbsp;
                <Button variant="secondary" size="sm" onClick={this.handleClose}>
                  Cancel
                </Button>
              </div>
            ) : (
              <Button variant="outline-secondary" size="sm" onClick={this.handleClose}>
                Ok
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertTable);
